module Elma.ViewModels {
    export class MiniCartViewModel extends Tapas.ViewModels.MiniCartViewModel {
        public CartTotalAmount = ko.observable(0);
        public CartTotalAmountNoVat = ko.observable(0);
       

        constructor() {
            super();
        }


        public EverythingHasLoaded = () => {
            // here we wait for our foreach to finish, and update data accordingly
            // without this handler, the data will return an empty observable on first try
            this.CartTotalAmountNoVat(this.Cart().AmountWithoutVAT());
            this.CartTotalAmount(this.Cart().Amount());          
        }
    }
}